import { render } from "./KlaipedaPort.vue?vue&type=template&id=641a96ab&scoped=true"
import script from "./KlaipedaPort.vue?vue&type=script&lang=js"
export * from "./KlaipedaPort.vue?vue&type=script&lang=js"

import "./KlaipedaPort.vue?vue&type=style&index=0&id=641a96ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641a96ab"]])

export default __exports__